import axios from 'axios';
import { orderBy } from 'lodash';
import { getHaulingCompaniesQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';

const getHaulingCompanies = async () => {
    try {
        const useExpressAuth = Split.getBooleanTreatment('use_express_auth_endpoints');
        const authQueryBuilder = useExpressAuth ? buildExpressQuery : buildLoopbackQuery;
        const fields = ['id', 'name'];
        const haulingCompaniesQuery = getHaulingCompaniesQuery({ fields, filterDeleted: true, queryBuilder: authQueryBuilder });
        const haulingCompaniesRequest = axios.get(haulingCompaniesQuery);

        const { data } = await haulingCompaniesRequest;
        if (useExpressAuth) {
            renameKey(data, '_id', 'id');
        }
        return orderBy(data, ['name'], ['asc']);
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getHaulingCompanies;
